module.exports = __webpack_public_path__ + "static/img/eoffice-logo.8843de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eoffice-logo.png
// module id = i1Bv
// module chunks = 109